module.exports = __webpack_public_path__ + "assets/img/4_68.ddb3ca56.jpg";